import {
  MockMap,
} from '@ama-sdk/core';
import {
  createMockData,
} from '@dapi/sdk/spec';
import {
  orderEligibilitiesMockEligibleToRefundWithUnOneWay,
  orderForUnOnlyOnewayChangeNotEligible,
} from '../../../mock/data';
import {
  flightDisruptionWarning,
  orderNotEligibleForRefundWarning,
} from '../../../mock/dictionaries';

export const unOnlyOneWayChangeNotEligibleMock: MockMap = {
  retrieveOrder: [createMockData(orderForUnOnlyOnewayChangeNotEligible, [], [flightDisruptionWarning])],
  getOrderEligibilities: [createMockData(orderEligibilitiesMockEligibleToRefundWithUnOneWay, [], [orderNotEligibleForRefundWarning])]
};
